<!-- /src/components/Course/SessionItem.vue -->
<template>
  <CourseSessionLayout class="layout--session layout--header--has-interactions">
    <template v-if="post" v-slot:header>
      <h2
        class="page-header"
        v-on="{click: () => changeSession()}"
      ><span v-html="post.title"></span>
      </h2>
      <div>
        <div v-if="percentViewed !== 'false'" class="percent-completed">
          <span v-if="percentViewed > 100 || isComplete"
            class="button__icon button--large"
          >
            <i class="icon fa fa-check-circle"></i>
          </span>
          <span v-else>{{ percentViewed }}% complete</span>
        </div>
        
        <PostInteractions
          :post="post"
          @sessioncomplete="sessionCompleted"
          :removeButtons="['progress']"
          />
      </div>
    </template>
    <template v-if="isCurrent" v-slot:content>
      <div 
        class="layout--session--container"
      >
        <div class="body-content">
          <div v-if="(!hasMedia && isDesktop)" class="session__image">
            <img :src="post.featured_media.post" alt="" />
          </div>
          <div v-if="hasMedia" class="session__media-element">
            <div v-if="isAudio && isDesktop" class="session__image">
              <img :src="post.featured_media.post" alt="" />
            </div>
            <!-- <MediaPlayer :mediaID="mediaID" :key="mediaID" :post="post" :startTime="startTime" :removePlayerOptions="['progress']" /> -->
            <MediaPlayer :mediaID="mediaID" :key="mediaID" :post="post" :startTime="startTime" @mediaComplete="sessionCompleted" @currentTime="updateCurrentTime" @percentageViewed="updatePercentViewed" @nextMedia="pushNextSession" />
            <TableOfContents :post="post" @jumpTo="updateStartTime" />
          </div>
        </div>
      </div>
    </template>
  </CourseSessionLayout>
</template>

<script>
import _isUndefined from 'lodash/isUndefined'
import PostInteractions from '@/components/common/PostInteractions'
import CourseSessionLayout from '@/components/layouts/CourseSessionLayout'
import MediaPlayer from '@/components/Session/Media'
// import SessionSidebar from '@/components/Session/Sidebar'
import Downloadable from '@/components/common/Downloadable'
import Loader from '@/components/common/Loaders/Loader'
import TableOfContents from '@/components/MediaElements/TableOfContents'
import secondsConversions from '@/components/common/utils/filters/secondConversions'
// import Card from '@/components/common/Card/Card'
import postMixin from '@/mixins/postMixin'
import resizeMixin from '@/mixins/resizeMixin'
import { deepSearch, checkNested } from '@/components/common/utils/helpers.js'

export default {
  mixins: [postMixin, resizeMixin],

  data() {
    return {
      tocVisible: false,
      startTime: 0,
      completingSession: false,
      progressButton: false,
    }
  },

  props: {
    post: {
      type: Object,
      required: true,
    },
    next: {
      type: Object,
      required: true,
    },
  },

  computed: {
    // post() {
    //   const output = this.$store.getters['posts/findItemByProp'](
    //     'sessions',
    //     this.$route.params.slug,
    //     'slug',
    //   )

    //   if (output) this.$store.dispatch('updatePageTitle', 'Session: ' + output.title.rendered)
    //   return output
    // },

    isCurrent() {
      const { post, $route } = this
      return $route.hash != '' && $route.hash.replace('#', '') == post.slug
    },

    mediaID() {
      const { post, isVideo, isAudio } = this
      const {acf} = post
      if (isVideo) return acf.video_id || null
      if (isAudio && acf.audio_file) return acf.audio_file.ID || null
      return null
    },

    audioID() {
      const { post, isAudio } = this
      if (isAudio && post.acf && post.acf.audio_file && post.acf.audio_file.ID) {
        return post.acf.audio_file.ID
      }
      return false
    },

    bodyContent() {
      const { section_content } = this.post.acf
      let output = false
      if (section_content && section_content.length > 0) {
        output = ''
        section_content.forEach(section => {
          output += `${section.title}${section.content}`
        })
      }
      return output
    },

    isVideo() {
      if (this.post.session_type[0] === 'video') {
        return true
      }
      return false
    },

    isAudio() {
      if (this.post.session_type[0] === 'audio') {
        return true
      }
      return false
    },

    hasMedia() {
      if (
        this.post.session_type[0] === 'video' ||
        this.post.session_type[0] === 'audio'
      ) {
        return true
      }
      return false
    },

    downloadableFiles() {
      const { post } = this
      const files = []
      let downloadableFiles = deepSearch(post, ['acf', 'downloadable_files'])
      if (Array.isArray(downloadableFiles)) {
        downloadableFiles.forEach(file => {
          files.push(file.file)
        })
        return files
      }
      return false
    },

    additionalElements() {
      const { downloadableFiles } = this
      return downloadableFiles
    },

    mediaOnly() {
      const { bodyContent, hasMedia, downloadableFiles } = this
      return !(bodyContent || downloadableFiles) && hasMedia
    },
  },

  filters: {
    ...secondsConversions,
  },

  methods: {
    updateStartTime(event) {
      this.startTime = event
    },

    jumpToTime(time) {
      this.startTime = time
    },

    checkForCurrentTimestamp() {
      if (!_isUndefined(this.currentInteraction)) {
        if ( this.currentInteraction.mediaType == 'video' || this.currentInteraction.mediaType == 'audio') {
          const { timestamp } = this.currentInteraction
          this.jumpToTime(timestamp)
        }
      } else {
        setTimeout(() => {
          this.checkForCurrentTimestamp()
        }, 500)
      }
    },

    updateCurrentTime(emitted) {
      let emitObj = {}
      if (this.currentInteraction) {
        this.currentInteraction.timestamp = emitted
        emitObj = {
          ...(this.currentInteraction)
        }
      } else {
        const { post } = this
        emitObj = {
          id: post.id,
          type: post.type,
          timestamp: emitted,
        }
      }
      this.$emit('trackCurrentTime', emitObj)
    },

    changeSession() {
      const { $route, post } = this
      // this.$emit('updateCourse')

      this.$router.push({
        path: $route.path,
        hash: this.post.slug
      })
    },

    sessionCompleted() {
      const { isCurrent, $route, next, isComplete } = this
      if (isCurrent) {
        if (!this.isComplete) {
          // removed this.markComplete() here because now it is automated by the player
          this.isComplete = true
          this.post['dateCompleted'] = new Date().toISOString()
          this.$emit('updateCourse', this.post)
          this.markComplete()
        }

        // this.completingSession = false
        // this.$forceUpdate()
      }
    },

    pushNextSession() {
      const { $route, next } = this

        this.$router.push({
          path: $route.path,
          hash: next.slug,
          query: {
            autostart: true
          }
        })
    },

    checkProgressButton() {
      const { type, slug, post, isCurrent } = this
      const { dateCompleted, dateStarted } = post
      // console.log({isCurrent,dateCompleted,slug})
      // this.progressButton = !isCurrent && !(typeof dateCompleted == 'undefined' || dateCompleted == false) ? 'Review Again' : (!isCurrent && !(typeof dateStarted == 'undefined' || dateStarted == false) ? 'Continue' : false)
    },

    updatePercentViewed(percent) {
      this.percentViewed = percent
    },

    // noSkippingAhead() {
    //   const msg = `We are sorry. Skipping forward is not allowed!`
    //   this.$store.dispatch('notification/add', {
    //     type: 'error',
    //     msg,
    //     closable: false,
    //     autoClose: true,
    //   })
    // }

  },

  watch: {
    isCurrent(active) {
      if (active) {
        this.visitedPost()
        this.post.dateStarted = true
      }
    },
    isComplete(complete) {
      if (complete) {
        this.$forceUpdate()
      }
    },
  },


  beforeDestroy() {
    // this.post = {}
  },

  components: {
    CourseSessionLayout,
    Loader,
    MediaPlayer,
    Downloadable,
    TableOfContents,
    PostInteractions,
    // Card,
  },

  mounted() {
    this.checkProgressButton()
    this.checkForCurrentTimestamp()
    this.getPercentViewed()
    // document.title = this.post.title.rendered
    if (this.isCurrent) {
      // setInterval(this.visitedPost(), 0)
      // console.log()
      // this.visitedPost()
      this.post.dateStarted = true
    }
  },

  beforeMount() {

  },
}
</script>

<style scoped>

.page-header {
  margin: 0;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-gap: 1rem;

  span {
    cursor: pointer;
    display: grid;
    line-height: 2;
    grid-template-rows: 1px 1fr 1px;

    &:before, &:after {
      content: '';
      height: 100%;
      left: 0;
      right: 0;
      background-color: var(--brandAccent);
      transition: all 500ms ease;
      opacity: 0;
    }

    &:before {
      transform: translateY(-1rem);
    }

    &:after {
      transform: translateY(1rem);
    }

    &:hover {
      &:before, &:after {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }
}

.layout--session {
  &--container {
    display: grid;
    align-items: start;
  }

  &--additional-content,
  &--split-body {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
    display: grid;
    @media (--desktop) {
      grid-template-columns: 7fr 3fr;
    }
  }

  &--media-only {
    width: calc(60% - 1rem);
    /* margin: 0 auto; */
  }

  .body-content {
    display: grid;
    grid-gap: 2rem;

  }

  .session {
    &__content {
      /* border-radius: var(--borderRadiusSmall); */
      /* overflow: hidden; */

      @media (--tablet) {
        border-radius: 0;
      }
    }


    &__body-content {
      /* padding: var(--itemSpacing) 0 0 0; */
      /* margin-top: 2rem; */
      width: 100%;
      /* max-width: calc(100% - 2rem); */

      a {
        text-decoration: underline;
      }

      ol {
        list-style: decimal;
        margin-left: 1rem;

        li {
          ol {
            list-style: lower-alpha;
            margin-left: 1.5rem;
          }
        }
      }

      ul {
        margin-left: 1rem;
        list-style-type: square;
      }

      blockquote {
        border-left: 5px solid var(--gray);
        padding-left: 1rem;
      }
    }

    &__attachments {
      &__title {
        color: var(--gray);
        font-weight: var(--fontWeightBold);
        font-size: 0.8em;
        text-transform: uppercase;
        margin: 0 0 0.5rem;
      }
    }

    &__related-content {
      &--container {
        margin-bottom: 3rem;
        &__items {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(8rem, 1fr));
          grid-gap: 1rem;
        }
      }
    }
  }
}

.percent-completed {
  font-weight: 700;
  font-size: 1rem;
  align-self: center;
  color: var(--BrandPrimary);
}
.additional-elements {
  > div {
    margin-bottom: 2rem;

    &:last-child {
      margin-bottom: 0
    }
  }
}


.downloadable-items {
  display: grid;
  grid-gap: .5rem;
}

</style>
